import React from 'react';
import { Avatar } from '@hub/avatar';
import { Box } from '@hub/box';
import { Button } from '@hub/button';
import { UserMediumIcon } from '@hub/icon';
import { Text } from '@hub/text';
import useIsMounted from '../../hooks/use-is-mounted';
import { useHeaderProps } from './header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderMembership = () => {
  const {
    user,
    onClickSecondaryMenu,
    onClickLogin
  } = useHeaderProps();
  const isLoggedIn = user === null || user === void 0 ? void 0 : user.isLoggedIn;
  const firstName = user === null || user === void 0 ? void 0 : user.firstName;
  const onClick = user !== null && user !== void 0 && user.isLoggedIn ? onClickSecondaryMenu : onClickLogin;
  const isMounted = useIsMounted();
  if (!isMounted) {
    return null;
  }
  if (isLoggedIn) {
    return /*#__PURE__*/_jsx(Button, {
      size: "icon-lg",
      variant: "headerButton",
      onClick: onClick,
      "aria-label": 'membership menu',
      textAlign: "left",
      textTransform: "none",
      fontWeight: "initial",
      leftIcon: /*#__PURE__*/_jsx(Avatar, {
        name: firstName !== null && firstName !== void 0 ? firstName : undefined,
        "data-id": "header_header-membership_HeaderMembership_Avatar"
      }),
      "data-id": "header_header-membership_HeaderMembership_Button",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: ['none', null, 'block']
        },
        "data-id": "header_header-membership_HeaderMembership_Button_Box",
        children: [/*#__PURE__*/_jsx(Text, {
          fontSize: "font-sm",
          tone: "strong",
          "data-id": "header_header-membership_HeaderMembership_Box_Text",
          children: "Account"
        }), /*#__PURE__*/_jsx(Text, {
          fontSize: "font-xs",
          tone: "neutral",
          "data-id": "header_header-membership_HeaderMembership_Box_Text_4",
          children: "Settings"
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    size: "icon-lg",
    variant: "headerButton",
    colorScheme: "licorice",
    onClick: onClick,
    "aria-label": "membership login or sign up",
    textAlign: "left",
    textTransform: "none",
    fontWeight: "initial",
    leftIcon: /*#__PURE__*/_jsx(UserMediumIcon, {
      boxSize: "size-icon-md",
      "data-id": "header_header-membership_HeaderMembership_UserMediumIcon"
    }),
    "data-id": "header_header-membership_HeaderMembership_Button",
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: ['none', null, 'block']
      },
      "data-id": "header_header-membership_HeaderMembership_Button_Box",
      children: [/*#__PURE__*/_jsx(Text, {
        fontSize: "font-sm",
        tone: "strong",
        "data-id": "header_header-membership_HeaderMembership_Box_Text",
        children: "My account"
      }), /*#__PURE__*/_jsx(Text, {
        fontSize: "font-xs",
        tone: "neutral",
        "data-id": "header_header-membership_HeaderMembership_Box_Text_9",
        children: "Login or Sign up"
      })]
    })
  });
};